import { ROUTES } from '@/constants/routes'
import type { UserRole } from '@/types/auth.types'

/** Dashboard di destinazione post-login in base al ruolo. */
export function dashboardFor(role: UserRole): string {
  if (role === 'ADMIN')    return ROUTES.ADMIN.DASHBOARD
  if (role === 'OPERATOR') return ROUTES.OPERATOR.DASHBOARD
  if (role === 'USER')     return ROUTES.USER.DASHBOARD
  return ROUTES.HOME
}
